<template>
   <div class="slider-container">
        <transition-group class="slider" name="slide" tag="div">
            <div class="img-slider" v-for="i in [currentIndex]" :key="i">
                <img :src="currentImg" />
                <div class="slider-content" v-html="slideTest"></div>
            </div>
           
        </transition-group>
        <div class="nav-slider">
            <div @click="goItem(index)"
                class="nav-item" 
                v-for="(item, index) in images" :key="index"
                :class='{active: index === currentImageIndex}'>
                <span></span>
            </div>
        </div>
   </div>

    
</template>

<script>

import Network from '@/common/lib/Network';

export default {
    data() {
        return {
            images: [
                "slider-0",
                "slider-1",
                "slider-2",
                "slider-3"
            ],
            slideTest: '',
            currentIndex: 0,
            currentImageIndex: 0,
            timer: null
        }
    },
    mounted() {
        this.startSlider();
    },
    methods: {
        startSlider() {
            this.timer = setInterval(this.next, 8000);
        },
        next() {
            this.currentIndex += 1;
        },
        goItem(x) {
            this.currentIndex = x
        }
    },
    computed: {
        currentImg() {

            console.error()

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.currentImageIndex = Math.abs(this.currentIndex) % this.images.length;

          // eslint-disable-next-line vue/no-async-in-computed-properties
          Network.execute('GET', 'sliderimg', {
            index: this.currentImageIndex,
            lang: this.$store.getters['application/get_application_user'].lang
          }).then(res => {
            if (res.data !== false) {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.slideTest = res.data
            } else {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.slideTest = ''
            }
          });

          return `${process.env.VUE_APP_API_URL}static/slider/`+this.images[Math.abs(this.currentIndex) % this.images.length]+'/'+this.images[Math.abs(this.currentIndex) % this.images.length]+'.jpg?d='+new Date().getTime();
        }
    }
}
</script>

<style scoped>

.slider-container {
    position: relative; 
    width: 100%;
    overflow: hidden;
    height: 600px;
    max-width: 100%;
    margin: auto;
}
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
    transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
  opacity: 0;
}
.img-slider{
    position: absolute;
    width: 100%;
}
.img-slider img{
   width: 100%;
}
.nav-slider {
    position: absolute;
    z-index: 100;
    bottom: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px
}
.nav-slider .nav-item {
    width: 12px;
    height: 12px;
    background-color: rgba(248,134, 153);
    border-radius: 50%;
    margin: 0px 6px;
}
.nav-slider .nav-item.active {
    background-color: #fff;
}
.nav-slider .nav-item:hover{
    cursor: pointer;
}
.slider-content {
    z-index: 1000;
}

</style>